import clsx from "clsx"
import "./CustomIconButton.scss"
import {BTN_ACTIONS} from "../../utils/Constant";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import {useMemo} from "react";
import {IObject} from "../../models/models";
import OCTTooltip from "../tooltip";

type Props = {
  children: JSX.Element
  onClick: () => void
  variant: "delete" | "edit" | "print" | "view" | "evaluate"
  disabled?: boolean
  tooltip?: string
  hideTooltip?: boolean
}

const CustomIconButton = (props: Props) => {
  const {children, onClick, variant, disabled, tooltip, hideTooltip = false} = props;
  const {lang} = useMultiLanguage();
  const toolTipByVariant = useMemo(() => {
    let item: IObject = {}

    for (const [key, value] of Object.entries(BTN_ACTIONS)) {
      item[value] = lang(`BTN.${key}`);
    }
    return item;
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const tooltipText = tooltip || toolTipByVariant[variant] || "";

  return (
    <div className="tooltip-container">
      {(children && !hideTooltip) && (
        <OCTTooltip title={tooltipText}>
          <div
            className={clsx("border-0 bg-transparent px-0", variant, { "disabled-icon": disabled })}
            onClick={() => {
              if (disabled) return;
              onClick();
            }}
          >
            {children}
          </div>
        </OCTTooltip>
      )}
    </div>
  )
}

export default CustomIconButton;
